import { Card } from '../components/ui/Card'
import { CardHeader } from '../components/ui/Card'
import { api } from '../utils/api'
import { useState, useEffect } from 'react'

export default function MonitoringPage() {
  const [health, setHealth] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get('/api/health')
      .then(res => { setHealth(res.data); setLoading(false) })
      .catch(() => setLoading(false))
  }, [])

  if (loading) return <div className="p-6 text-text-muted">Загрузка...</div>

  const components = health?.components || {}
  const statusColor = health?.status === 'ok' ? 'text-status-normal' : 'text-status-critical'

  return (
    <div className="p-6 animate-fade-in">
      <h1 className="text-2xl font-bold mb-6">Мониторинг</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card>
          <CardHeader title="Статус сервисов" />
          <div className="divide-y divide-border/50">
            {[
              { label: 'Database', status: components.database_core },
              { label: 'TimescaleDB', status: components.timescaledb_extension },
              { label: 'Alembic', status: components.migrations_uptodate },
            ].map(({ label, status }) => (
              <div key={label} className="flex items-center justify-between py-2 px-4">
                <span className="text-sm">{label}</span>
                <span className={`text-sm font-mono capitalize ${status === 'ok' ? 'text-status-normal' : 'text-status-warning'}`}>
                  {status ?? '—'}
                </span>
              </div>
            ))}
          </div>
        </Card>
        <Card>
          <CardHeader title="Версия" />
          <div className="p-4">
            <div className="font-mono text-lg">{health?.version ?? '—'}</div>
            <div className="text-sm text-text-secondary mt-2">
              Статус: <span className={statusColor}>{health?.status ?? '—'}</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
